// extracted by mini-css-extract-plugin
module.exports = {"top-right":"_2a6cc2b0","top-left":"_d58c8768","attention":"_c27b415f","bottom-right":"_f2c03456","bottom-left":"_46c4a247"};